<template>
  <el-dialog
    top="10vh"
    :title="form.id ? '编辑' : '新增'"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="showModel"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="120px"
      size="small"
      label-suffix=": "
    >
      <el-form-item label="固件型号" prop="firmwareModelId">
        <Select
          :query="$api.fota.firmware_page"
          v-model="form.firmwareModelId"
          placeholder="请选择"
          :labelOptions="{
            key: 'id',
            value: 'name'
          }"
        />
      </el-form-item>
      <el-form-item label="固件版本号" prop="version">
        <el-input v-model.trim="form.version" placeholder="格式为00.00.00"></el-input>
      </el-form-item>
      <el-form-item label="固件别名">
        <el-input
          v-model.trim="form.versionAlias"
          placeholder="最多16个字符"
          :maxlength="16"
        ></el-input>
      </el-form-item>
      <el-form-item label="固件上传" :required="!form.id">
        <el-upload
          ref="upload"
          action=""
          :multiple="false"
          :auto-upload="false"
          :limit="1"
          :on-change="upload"
          :on-exceed="explainFile"
          :on-remove="delFile"
          accept=".bin"
          :file-list="fileList"
        >
          <el-button size="small">选择文件</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          :rows="3"
          maxlength="100"
          show-word-limit
          v-model.trim="form.remark"
          resize="none"
          placeholder="备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="edit-footer">
      <el-button size="small" @click="close">取消</el-button>
      <el-button type="primary" size="small" @click="save" :loading="loading">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Select from '@/components/CommonForm/Select'
export default {
  props: {
    showModel: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  components: {
    Select
  },
  data() {
    return {
      firmwareType: 'LOWER',
      form: {
        id: '',
        firmwareModelId: '',
        version: '',
        versionAlias: '',
        file: '',
        remark: ''
      },
      rules: {
        firmwareModelId: [
          {
            required: true,
            message: '请选择固件型号',
            trigger: ['blur', 'change']
          }
        ],
        version: [
          {
            required: true,
            message: '请输入固件版本号',
            trigger: 'blur'
          }
        ]
      },
      fileList: [],
      loading: false
    }
  },
  mounted() {
    if (this.row.id) {
      this.form = { ...this.row }
    }
  },
  methods: {
    explainFile() {
      this.$message({
        message: '已有固件，请先删除现有固件',
        type: 'warning'
      })
    },
    upload(file) {
      this.form.file = file.raw
    },
    delFile() {
      this.form.file = ''
    },
    close() {
      this.$emit('update:showModel', false)
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    save() {
      if (!this.checkForm()) return
      if (!this.form.file && !this.form.id) {
        this.$message.error('固件文件不能为空')
        return false
      }
      this.loading = true

      let params = new FormData()
      params.append('id', this.form.id)
      params.append('firmwareModelId', this.form.firmwareModelId)
      params.append('version', this.form.version)
      params.append('versionAlias', this.form.versionAlias)
      params.append('file', this.form.file)
      params.append('remark', this.form.remark)
      params.append('firmwareType', this.firmwareType)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let api = this.form.id
        ? this.$api.fota.firmware_version_update
        : this.$api.fota.firmware_version_insert
      this.$ajax
        .post(api, params, config)
        .then(() => {
          this.$message.success((this.form.id ? '编辑' : '新增') + '固件成功')
          this.close()
          this.$emit('refresh')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.textarea-div {
  width: 342px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  /deep/ .el-textarea {
    textarea {
      border: none;
    }
  }
  .textarea-more {
    margin: 0 15px;
    padding: 8px 0;
    border-top: 1px solid #dcdcdc;
    .file-type {
      font-size: 12px;
      color: #999999;
    }
    .total {
      float: right;
      line-height: 38px;
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>
